import { render } from "./FormManterCategoriaAtendimento.vue?vue&type=template&id=bc54f1da"
import script from "./FormManterCategoriaAtendimento.vue?vue&type=script&lang=js"
export * from "./FormManterCategoriaAtendimento.vue?vue&type=script&lang=js"

import "./FormManterCategoriaAtendimento.vue?vue&type=style&index=0&id=bc54f1da&lang=css"
/* custom blocks */
import block0 from "./FormManterCategoriaAtendimento.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__